import React from "react";

const ActivationPending = () => (
  <div>
    <h2>Activation Pending!</h2>
    <p>
      Your payment has been received! Check back here shortly to see the channel
      in action.
    </p>
    <p>
      Please note it may take several hours before any data displays. If the
      channel still isn't available after 24 hours contact us at
      support@weathersv.com
    </p>
  </div>
);

export default ActivationPending;
